<div class="content-heading">
  <div class="header-Container">
    <h3>Vales de equipo</h3>
    <small>Vales de equipo</small>
  </div>
</div>
<div class="container-fluid">
<div class="form-container">
  <div class="row">
    <div class="form-group col col-md-4">
      <label class="form-label">Fecha Inicio</label>
      <input class="form-control"
             type="date"
             [(ngModel)]="selectedDate"
             min="{{ minDate }}"
             (change)="onDateSelected('start')" />
    </div>

  <div class="form-group col col-md-4">
    <label class="form-label">Fecha Final</label>
    <input class="form-control"
           type="date"
           [(ngModel)]="selectedDateFinal"
           max="{{ maxDate }}"
           (change)="onDateSelected('end')" />
  </div>

      <div class="form-group col col-md-4">
          <label class="form-label">Organizaci&oacute;n</label>
          <select title="Org" class="form-control" [(ngModel)]="orgId" (ngModelChange)="changeFilterOrg($event)" required>
              <option [value]="0" selected>TODOS</option>
              <option *ngFor="let unit of org" [value]="unit.UnitId">{{unit.OrgName}}</option>
          </select>
      </div>
    </div>
    <div class="row">
      <div class="form-group col col-md-4">
          <label class="form-label">Centro de ventas</label>
          <ceq-unit-autocomplete [loading]="working"
              [unitOrgId]="orgId"
              [listType]="'CEVE'"
              (onUnitClear)="clearOutputNode()"
              (onUnitSelected)="setOutputNode($event)">
          </ceq-unit-autocomplete>


          
      </div>
  

      <div class="form-group col col-md-4">
          <label class="form-label">Canal</label>
          <br>

 <!-- Botón que despliega el dropdown -->
 <div class="dropdown" [class.show]="dropdownOpenChannel">
  <button class="btn btn-default dropdown-toggle" type="button" (click)="toggleDropdownChannel()"
  style="border: 2px solid #e9eaec; border-radius: 5px; padding: 10px 200px;">
    Seleccionar Canal <span class="caret"></span>
  </button>
  <!-- Contenedor del dropdown -->
  <div class="dropdown-menu" [class.show]="dropdownOpenChannel" style="padding: 10px ; max-height:300px; border-bottom: 0cap; ">
    <!-- Opción "TODOS" -->
    <div>
      <label>
        <input
          type="checkbox"
          [(ngModel)]="selectAllChannels"
          (change)="toggleSelectAllChannels(); closeDropdown()">
        TODOS
      </label>
    </div>
    <hr>

    
    <!-- Lista de canales con checkbox -->
    <div *ngFor="let ch of channelList">
      <label>
        <input
          type="checkbox"
          [value]="ch.ChannelCode"
          [checked]="selectedChannels.includes(ch.ChannelCode)"
          (change)="onChannelChange($event, ch.ChannelCode) ; closeDropdown()">
        {{ ch.ChannelName.toUpperCase() }}
      </label>
    </div>
  </div>
</div>
      </div>



      <div class="form-group col col-md-4">
        <label class="form-label">Rutas</label>
         <!-- Botón que despliega el dropdown -->
  <div class="dropdown" [class.show]="dropdownOpen">
    <button class="btn btn-default dropdown-toggle" type="button" (click)="toggleDropdown()"
    style="border: 2px solid #e9eaec; border-radius: 5px; padding: 10px 200px;">
      Seleccionar Rutas <span class="caret"></span>
    </button>
    <!-- Contenido del dropdown -->
    <div class="dropdown-menu" [class.show]="dropdownOpen" style="padding: 10px ; max-height:max-content; border-bottom: 0cap;">
      <!-- Opción "TODAS" -->
      <div>
        <label>
          <input 
            type="checkbox" 
            [(ngModel)]="selectAll" 
            (change)="toggleSelectAll(); closeDropdown()"
                     >
          TODAS
        </label>
      </div>
      <hr>
      <!-- Checkboxes para cada ruta -->
      <div *ngFor="let route of routes">
        <label>
          <input 
            type="checkbox" 
            [value]="route.RouteId" 
            [checked]="selectedRoutes.includes(route.RouteId)" 
            (change)="toggleRoutes($event, route.RouteId); closeDropdown()"
            [disabled]="noRoute">
           
          {{ route.RouteCode }} 
        </label>
      </div>
    </div>
  </div>
    </div>
    </div>

 
      <div class="form-group col col-md-4">
      <button
              [disabled]="working"
              type="button"
              class="mr-1 btn btn-labeled btn-outline-primary align-self-end"
              (click)="getPaybillListExpiredList()">
        <span class="btn-label">
          <i class="fa fa-search" *ngIf="!working"></i>
          <i class="fa fa-circle-o-notch fa-spin" *ngIf="working"></i>
        </span>
        <span>Buscar</span>
      </button>

    </div>
  </div>
</div>

<app-loading *ngIf="loading"></app-loading>
<div class="container-fluid" *ngIf="!loading">
  <div class="form-container">
      <div class="data-container black-text">
          <div class="d-flex">  
              <div class="column_width center-data" *ngFor="let header of cols">
                  <div class="column_width center-data background-nav-color"> {{header}}</div>
              </div>          
          </div>
          <div class="d-flex">
              <div class="row" *ngFor="let header of cols">
                  <div class="col">
                      <div class="column_width center-data" *ngFor="let row of loadData">
                          <!-- <input *ngIf="header == 'CEVE'" title="{{row[header]}}" type="text"  class="form-control center-data m-left" value="{{row[header]}}" name="{{row[header]}}" disabled>
                          <input *ngIf="header == 'CANAL'" title="{{row[header]}}" type="text"  class="form-control center-data m-left" value="{{row[header]}}" name="{{row[header]}}" hidden>
                           -->
                          <input title="{{row[header]}}"  class="form-control right-data m-left" 
                                value="{{row[header]}}" name="{{row[header]}}" required max="999" min="0" disabled>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <br>
  </div>
</div>  
